import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import Icon from "@/components/icon/Icon.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import QuestionAnswerImageUploader from "@/components/questions/QuestionAnswerImageUploader.vue";
import quizUtils from "@/util/quizUtils";
let ItemsMatching = class ItemsMatching extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "pairs", void 0);
    _defineProperty(this, "realtimePairs", []);
    _defineProperty(this, "activePair", null);
    _defineProperty(this, "displayPairDeletionDialog", false);
    // Drag-and-drop state
    _defineProperty(this, "dragStartIndex", null);
    _defineProperty(this, "dragOverIndex", null);
    _defineProperty(this, "isDraggable", true);
  }
  mounted() {
    this.initRealtimePairs(this.pairs);
  }
  onPairsChanged(pairs) {
    this.initRealtimePairs(pairs);
  }
  get LABEL_NB_MAX_CHARS() {
    return quizUtils.QUIZ_LABELS_NB_MAX_CHARS;
  }
  initRealtimePairs(pairs) {
    this.realtimePairs = structuredClone(pairs);
    this.realtimePairs.sort((a, b) => a.position - b.position);
  }
  handleMouseDown(event) {
    const target = event.target;
    this.isDraggable = !target.closest('input');
  }
  onPairItemBlur(pair, value) {
    const newItem = value.trim();
    if (!pair.itemImage && newItem !== pair.item?.trim()) {
      pair.item = newItem;
      this.emitPairsUpdated(pair);
    } else if (pair.itemImage && newItem !== pair.itemImage.imageLabel?.trim()) {
      pair.itemImage.imageLabel = newItem;
      pair.item = undefined;
      this.emitPairsUpdated(pair);
    }
  }
  onPairItemResponseBlur(pair, value) {
    const newItemResponse = value.trim();
    if (!pair.itemResponseImage && newItemResponse !== pair.itemResponse?.trim()) {
      pair.itemResponse = newItemResponse;
      this.emitPairsUpdated(pair);
    } else if (pair.itemResponseImage && newItemResponse !== pair.itemResponseImage.imageLabel?.trim()) {
      pair.itemResponseImage.imageLabel = newItemResponse;
      pair.itemResponse = undefined;
      this.emitPairsUpdated(pair);
    }
  }
  deletePair(pairToDelete) {
    if (this.realtimePairs.length > 2) {
      this.setActivePair(pairToDelete);
      this.displayPairDeletionDialog = true;
    }
  }
  onPairDeleteConfirm() {
    this.realtimePairs = this.realtimePairs.filter(pair => pair !== this.activePair);
    this.renumberPairsPositions();
    this.emitPairsUpdated();
    this.displayPairDeletionDialog = false;
    this.unsetActivePair();
  }
  onPairDeleteCancel() {
    this.displayPairDeletionDialog = false;
    this.unsetActivePair();
  }
  setActivePair(pairToDelete) {
    this.activePair = pairToDelete;
  }
  renumberPairsPositions() {
    this.realtimePairs.forEach((pair, index) => pair.position = index + 1);
  }
  unsetActivePair() {
    this.activePair = null;
  }
  emitPairsUpdated(activePair) {
    if (!this.duplicateItemsExist()) {
      this.$emit("pairsUpdate", this.realtimePairs, activePair);
    } else {
      WElMessage.showErrorMessage(this.$t('chapter.question.matching.errorAlert.multiPairsItem'));
    }
  }
  duplicateItemsExist() {
    const seen = new Map();
    let hasDuplicate = false;
    for (const p of this.realtimePairs) {
      for (const [val, baseField] of [[p.item || p.itemImage?.imageLabel, "item"], [p.itemResponse || p.itemResponseImage?.imageLabel, "itemResponse"]]) {
        const fieldImage = `${baseField}Image`;
        // on marque les champs incompletés
        if (baseField === "item") {
          p.isItemError = !p[baseField] && !p[fieldImage]?.imageLabel && (!!p.itemResponse || !!p.itemResponseImage?.imageLabel);
        }
        if (baseField === "itemResponse") {
          p.isItemResponseError = !p[baseField] && !p[fieldImage]?.imageLabel && (!!p.item || !!p.itemImage?.imageLabel);
        }
        if (!val) continue;
        if (seen.has(val)) {
          // on marque le champ en doublon
          hasDuplicate = true;
          if (baseField === "item") p.isItemError = true;
          if (baseField === "itemResponse") p.isItemResponseError = true;
          // marquer aussi le premier trouvé
          const first = seen.get(val);
          if (first.field === "item") first.pair.isItemError = true;
          if (first.field === "itemResponse") first.pair.isItemResponseError = true;
        } else {
          seen.set(val, {
            pair: p,
            field: baseField
          });
        }
      }
    }
    return hasDuplicate;
  }
  onDragStart(index) {
    this.dragStartIndex = index;
    this.dragOverIndex = index;
  }
  onDragEnter(index) {
    this.dragOverIndex = index;
  }
  onDragEnd() {
    this.dragStartIndex = null;
    this.dragOverIndex = null;
  }
  onDrop(index) {
    if (this.dragStartIndex === null) return;
    const from = this.dragStartIndex;
    const to = index;
    if (from !== to) {
      const moved = this.realtimePairs[from];
      const remaining = this.realtimePairs.filter((_, i) => i !== from);
      remaining.splice(to, 0, moved);
      this.realtimePairs = remaining;
      this.$nextTick(() => {
        this.renumberPairsPositions();
        this.emitPairsUpdated();
      });
    }
    this.onDragEnd();
  }
  onItemImageChange(uploadedImage, matchingPair) {
    matchingPair.itemImage = {
      imageName: uploadedImage.originalName,
      imageLabel: matchingPair.item,
      uploadTmpPath: uploadedImage.path
    };
    matchingPair.item = undefined;
    this.emitPairsUpdated();
  }
  onItemResponseImageChange(uploadedImage, matchingPair) {
    matchingPair.itemResponseImage = {
      imageName: uploadedImage.originalName,
      imageLabel: matchingPair.itemResponse,
      uploadTmpPath: uploadedImage.path
    };
    matchingPair.itemResponse = undefined;
    this.emitPairsUpdated();
  }
  onItemImageDelete(pair) {
    pair.item = pair.itemImage?.imageLabel;
    pair.itemImage = undefined;
    pair.isItemError = !pair.item;
    if (pair.item) {
      this.emitPairsUpdated();
    }
  }
  onItemResponseImageDelete(pair) {
    pair.itemResponse = pair.itemResponseImage?.imageLabel;
    pair.itemResponseImage = undefined;
    pair.isItemResponseError = !pair.itemResponse;
    if (pair.itemResponse) {
      this.emitPairsUpdated();
    }
  }
};
__decorate([Prop({
  default: []
})], ItemsMatching.prototype, "pairs", void 0);
__decorate([Watch("pairs")], ItemsMatching.prototype, "onPairsChanged", null);
ItemsMatching = __decorate([Component({
  components: {
    QuestionAnswerImageUploader,
    ConfirmDialog,
    WInput,
    Icon
  },
  emits: ['pairsUpdate']
})], ItemsMatching);
export default ItemsMatching;